<script setup lang="ts">
import type { DisciplineCode } from '@brighterly/lib-core-types/student-assessment/types'

import ImportCurriculumCard from './curriculum/ImportCurriculumCard.vue'

defineOptions({
  name: 'ToolsImportCurriculumPage',
})

const CURRICULUM_DISCIPLINES: readonly { code: DisciplineCode, label: string }[] = [
  { code: 'MATH', label: 'Math' },
  { code: 'ELA', label: 'ELA' },
]
</script>

<template>
  <div class="import-curriculum">
    <ImportCurriculumCard
      v-for="discipline in CURRICULUM_DISCIPLINES"
      :key="discipline.code"
      :discipline-code="discipline.code"
      :title="discipline.label"
    />
  </div>
</template>

<style scoped lang="scss" src="./ToolsImportCurriculumPage.scss" />
